<template>
  <footer class="footer">
    <span>Burg. H houtkoperlaan 9, Ochten</span> / <span>info@beautysalonsensi.nl </span> / <span> 06-48425210 </span>
  </footer>
</template>

<script>
export default {
  name: 'FooterPrismic'
}
</script>

<style scoped>
.footer {
  color: #F9EEE2;
  background: #787D69;
  padding: 40px 0;
  margin: 0 auto;
  text-align: center;
  border-top: 1px solid #fff;
}
.logo {
  width: 100px;
}
</style>
